import type { MinigameDefinition } from '@core/types';
import { AdventureConfig } from '@modules/adventure/config';
import { AdventureScene } from '@modules/adventure/AdventureScene';

/** Definicion publica del modulo de aventura para registrarlo en el catalogo. */
export const adventureMinigame: MinigameDefinition = {
  key: AdventureConfig.key,
  title: AdventureConfig.title,
  description: AdventureConfig.description,
  icon: AdventureConfig.icon,
  color: AdventureConfig.color,
  scene: AdventureScene,
};
